import { useCallback, useRef } from 'react'
import { DownloadType } from 'types'
import { jsPDF } from 'jspdf'
import { PDF_WIDTH, SCALE_VALUE } from 'constant'
import FileSaver from 'file-saver'
import { useActions } from 'hooks'
import domtoimage from 'dom-to-image'

export const useDownloadSlopeChart = () => {
  const { setShowDwnLoader } = useActions()
  const divRef = useRef<HTMLDivElement>(null)

  const generateImage = async () => {
    if (divRef !== null && divRef?.current) {
      return await domtoimage.toPng(divRef.current, { bgcolor: '#ffffff' }).then((dataUrl) => dataUrl)
    }
  }

  const handleDownload = useCallback(
    async (
      type: DownloadType,
      configuration: {
        fileName: string
        orientation?: 'portrait' | 'landscape'
        isSquareDownload?: boolean
      },
    ) => {
      const { fileName, isSquareDownload } = configuration

      try {
        await new Promise((resolve) => setTimeout(resolve, 0))
        const image = await generateImage()
        if (image) {
          if (type === 'pdf') {
            const img = new Image()
            img.src = image

            img.onload = () => {
              const ratio = img.width / img.height

              const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: [(PDF_WIDTH / ratio) * SCALE_VALUE, PDF_WIDTH * SCALE_VALUE],
              })

              const imgWidth = pdf.internal.pageSize.getWidth()
              const imgHeight = isSquareDownload
                ? (img.height * imgWidth) / img.width
                : pdf.internal.pageSize.getHeight()

              pdf.addImage(image, 'JPG', 0, 0, imgWidth, imgHeight)
              pdf.save(`${fileName}.pdf`)
            }
          } else {
            const extension = type === 'jpg' ? 'jpg' : 'png'
            FileSaver.saveAs(image, `${fileName}.${extension}`)
          }
        }
      } catch (error) {
        console.error('Error during download:', error)
      } finally {
        setShowDwnLoader(false)
      }
    },
    [divRef, generateImage],
  )

  return { handleDownload, divRef }
}
